import 'angular:locale/data:nl';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "nl";
